export default __webpack_public_path__ + "static/media/Referral page.c9cdcdce.jpg";